export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ15.1a5b7332.mp3";